import React from "react";

function AiRisksAndDefenses({
  aiPlaintiffFault,
  aiDefences = [],
  aiRisks = [],
}) {
  return (
    <div className="font-plexsans">
      <h2 className="text-2xl font-spectral text-navy mb-4">
        Risks & Defenses
      </h2>

      {/* Plaintiff Fault */}
      <div className="inline-block min-w-[220px] border border-[rgba(20,33,61,.12)] rounded-[10px] p-4 mb-4">
        <div className="text-[13px] text-[rgba(20,33,61,.5)]">
          Plaintiff fault
        </div>
        <div className="text-2xl font-semibold text-navy mt-1">
          {aiPlaintiffFault}
        </div>
      </div>

      {/* Defenses */}
      {aiDefences?.length > 0 && (
        <div className="mb-4">
          <div className="text-[13px] font-medium text-tan mb-2">
            Potential defenses
          </div>

          <ul className="space-y-1.5">
            {aiDefences.map((item, index) => (
              <li
                key={index}
                className="text-[14px] text-tan flex gap-2"
              >
                <span className="text-tan">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Risks */}
      {aiRisks?.length > 0 && (
        <div className="">
          <div className="text-[13px] font-medium text-tan mb-2">
            Litigation risks
          </div>

          <ul className="space-y-1.5">
            {aiRisks.map((item, index) => (
              <li
                key={index}
                className="text-[14px] text-blue-700 flex gap-2"
              >
                <span className="text-blue-700">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default AiRisksAndDefenses;
